// extracted by mini-css-extract-plugin
export var title = "question-item-module--title--sCa5Z";
export var icon = "question-item-module--icon--SxYYS";
export var description = "question-item-module--description--rWs5S";
export var item = "question-item-module--item--wAsRr";